import {useQueryClient} from "@tanstack/react-query";
import {getAnonId, track} from "analytics";
import {guestSession, sendQuickBookingCode, verifyQuickBooking} from "api/guest.api";
import {useAuth} from "context/AuthContext";

export const digitsOnly = (v) => String(v || "").replace(/\D/g, "");

/**
 * Quick booking sign-in: texts the existing 4-digit code, then verifies it,
 * creates the student account and signs it in. Both calls throw API errors
 * (use guestErrorCode / guestErrorMessage).
 */
export const useQuickBookingAuth = (teacherId) => {
    const {loginWithCustomToken} = useAuth();
    const queryClient = useQueryClient();

    const body = ({name, email, phone}) => ({name: name.trim(), email: email.trim(), phone_number: digitsOnly(phone)});

    const sendCode = async (contact, turnstileToken) => {
        await sendQuickBookingCode({...body(contact), turnstile_token: turnstileToken});
        track("quick_booking_code_sent", {teacher_id: teacherId});
    };

    const verify = async (contact, code) => {
        const data = await verifyQuickBooking({
            ...body(contact),
            code,
            guest_session: guestSession.get()?.token || "",
            anon_id: getAnonId(),
        });
        await loginWithCustomToken({firebaseToken: data.token_firebase, appToken: data.token});
        guestSession.clear();
        queryClient.invalidateQueries();
        track("quick_booking_verified", {teacher_id: teacherId});
        return data;
    };

    return {sendCode, verify};
};
